module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-configuration-item"
  }, [_c('b', [_vm._v(_vm._s(_vm.item.description) + " [ " + _vm._s(_vm.itemKey) + " ]")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column small-11"
  }, [(_vm.item.possibile === null && (_vm.item.type === 'string' || _vm.item.type === 'numeric')) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.item.default
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }) : (_vm.item.possibile !== null && (_vm.item.type === 'string' || _vm.item.type === 'numeric')) ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.value = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("- NOT SET -")]), _vm._l((_vm.item.possibile), function(p, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(p))])
  })], 2)]) : (_vm.item.possibile === null && (_vm.item.type === 'json')) ? _c('div', [_c('JsonConf', {
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : (_vm.item.type.split(':')[0] === 'array') ? _c('div', [(_vm.item.type.split(':')[1] === 'simple') ? _c('div', _vm._l((_vm.item.possibile), function(pos) {
    return _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.value),
        expression: "value"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": pos,
        "checked": Array.isArray(_vm.value) ? _vm._i(_vm.value, pos) > -1 : (_vm.value)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = pos,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.value = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.value = $$c
          }
        }
      }
    }), _c('span', [_vm._v(_vm._s(pos))])])
  }), 0) : (_vm.item.type.split(':')[1] === 'keyed') ? _c('div', [_vm._l((_vm.value), function(prop, iprop) {
    return _c('div', {
      staticClass: "row"
    }, [_c('DeleteConf', {
      on: {
        "click": function($event) {
          return _vm.deleteKeyed(iprop)
        }
      }
    }), _c('div', {
      staticClass: "column small-4"
    }, [_c('input', {
      attrs: {
        "type": "text",
        "disabled": "disabled"
      },
      domProps: {
        "value": iprop
      }
    })]), _c('div', {
      staticClass: "column"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.value[iprop]),
        expression: "value[iprop]"
      }],
      attrs: {
        "type": "text",
        "placeholder": "...insert value here..."
      },
      domProps: {
        "value": (_vm.value[iprop])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.value, iprop, $event.target.value)
        }
      }
    })])], 1)
  }), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectTmp),
      expression: "selectTmp"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectTmp = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.item.possibile), function(p) {
    return _c('option', {
      domProps: {
        "value": p
      }
    }, [_vm._v(_vm._s(p))])
  }), 0), _c('button', {
    staticClass: "button small",
    on: {
      "click": function($event) {
        return _vm.pushKeyed()
      }
    }
  }, [_vm._v("ADD")])], 2) : _c('div', [(_vm.itemKey === 'fleet_reservation_surveys') ? _c('div', {
    staticClass: "surveys"
  }, [_c('ReservationSurveyConfiguration', {
    attrs: {
      "value": _vm.value,
      "item": _vm.item
    }
  })], 1) : (_vm.itemKey === 'commercial_reservation_deposit_config') ? _c('div', {
    staticClass: "deposit"
  }, [_c('DepositConfiguration', {
    attrs: {
      "value": _vm.value,
      "item": _vm.item
    }
  })], 1) : (_vm.itemKey === 'system_client_custom_fields') ? _c('div', {
    staticClass: "custom-fields"
  }, [_c('ClientCustomFieldsConfiguration', {
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : (_vm.itemKey === 'system_fields_configuration') ? _c('div', {
    staticClass: "system-fields"
  }, [_c('SystemFieldsConfiguration', {
    key: _vm.itemKey,
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : (_vm.itemKey === 'fleet_ignore_user_position_for_vehicle') ? _c('div', {
    staticClass: "fleet-position"
  }, [_c('FleetPositionConfiguration', {
    attrs: {
      "value": _vm.value,
      "item": _vm.item
    }
  })], 1) : (_vm.itemKey === 'italian-e-invoice_split_payments') ? _c('div', {
    staticClass: "italian-e-invoice"
  }, [_c('ItalianEInvoiceSplitPaymentConfiguration', {
    attrs: {
      "value": _vm.value,
      "item": _vm.item
    }
  })], 1) : (_vm.itemKey === 'commercial_credit_bonus_configuration') ? _c('div', {
    staticClass: "credit-bonus"
  }, [_c('button', {
    staticClass: "button small",
    on: {
      "click": function($event) {
        _vm.pushEmptyValue(_vm.item.type.split(':')[1].split(','))
      }
    }
  }, [_vm._v("Add new bonus")]), _vm._l((_vm.value), function(elem, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "column shrink"
    }, [_c('dropdown', {
      attrs: {
        "icon": 'fa fa-ellipsis-v fa-2x action',
        "position": 'top'
      }
    }, [_c('div', {
      staticClass: "dropdown-buttons"
    }, [_c('CreditBonusConfiguration', {
      attrs: {
        "item": elem
      },
      on: {
        "update": _vm.update
      }
    }), _c('button', {
      staticClass: "button",
      on: {
        "click": function($event) {
          return _vm.value.splice(index, 1)
        }
      }
    }, [_vm._v("Delete")]), (elem.amount !== null) ? _c('CreditBonusInformation', {
      attrs: {
        "item": elem
      }
    }) : _vm._e()], 1)])], 1), _c('div', {
      staticClass: "column"
    }, [_c('label', [_vm._v("Name")]), _c('div', [_vm._v(_vm._s(elem.name))])]), _c('div', {
      staticClass: "column"
    }, [_c('label', [_vm._v("Amount")]), _c('div', [_vm._v(_vm._s(elem.amount))])]), _c('div', {
      staticClass: "column"
    }, [_c('label', [_vm._v("Promo amount")]), _c('div', [_vm._v(_vm._s(elem.promo_amount))])])])
  })], 2) : _vm._l((_vm.value), function(elem, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('DeleteConf', {
      on: {
        "click": function($event) {
          return _vm.value.splice(index, 1)
        }
      }
    }), _vm._l((elem), function(val, inx) {
      return _c('div', {
        staticClass: "column"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.value[index][inx]),
          expression: "value[index][inx]"
        }],
        attrs: {
          "type": "text",
          "placeholder": inx
        },
        domProps: {
          "value": (_vm.value[index][inx])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.value[index], inx, $event.target.value)
          }
        }
      })])
    })], 2)
  }), (_vm.itemKey !== 'commercial_credit_bonus_configuration') ? _c('button', {
    staticClass: "button small",
    on: {
      "click": function($event) {
        _vm.pushEmptyValue(_vm.item.type.split(':')[1].split(','))
      }
    }
  }, [_vm._v("ADD")]) : _vm._e()], 2)]) : _c('div', [_c('h1', [_vm._v("TYPE NOT MANAGED!")]), _c('pre', [_vm._v(_vm._s(_vm.item))])])]), _c('div', {
    staticClass: "column small-1"
  }, [_c('button', {
    staticClass: "button small",
    on: {
      "click": _vm.update
    }
  }, [_vm._v("UPDATE")]), (_vm.item._translatable) ? [_c('TranslateField', {
    attrs: {
      "group": "entities",
      "field": _vm.item._translatable
    }
  })] : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2b9396c2!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/ConfigurationItem.vue
// module id = 2358
// module chunks = 1